import { render, staticRenderFns } from "./pro-chiose-tab-position.vue?vue&type=template&id=e587cd3e";
import script from "./pro-chiose-tab-position.vue?vue&type=script&lang=jsx";
export * from "./pro-chiose-tab-position.vue?vue&type=script&lang=jsx";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;